import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/common/backIcon.png'
import _imports_1 from '@/assets/common/plus.png'
import _imports_2 from '@/assets/common/head_icon.jpg'
import _imports_3 from '@/assets/themeThree/search_icon.png'
import _imports_4 from '@/assets/common/loadMore.png'


const _hoisted_1 = { class: "popupContainer" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "avatar_btn"
}
const _hoisted_4 = { class: "more_img" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "searchField" }
const _hoisted_7 = {
  class: "left_container",
  style: {"overflow-y":"scroll","height":"80%"}
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "groupText" }
const _hoisted_11 = {
  key: 0,
  class: "right_container"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  style: {"display":"flex","justify-content":"center","padding-top":"15%"}
}

import { ref, computed, onMounted, onBeforeUnmount, PropType, watch } from 'vue'
import GameCard from './components/gameCard.vue'
import { useUserStore } from '@/stores/user'
import { GameData, TAB_LIST } from '@/view/game/supportScript';
import NoData from '../components/common/noData.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'gamePopup',
  props: {
    dataSet: {
        type: Object as PropType<GameData>,
        required: true
    }
},
  emits: ['update:show', 'update:showPopover', 'open', 'close', 'goToProfile', 'selectGroup', 'loadMoreGame', 'goToDeposit', 'goToPlayGame', 'openRegisterPopup', 'searchGames', 'onClickTab', 'getGameTabData'],
  setup(__props, { expose: __expose, emit: __emit }) {

const userStore = useUserStore()
const popoverRef = ref<HTMLElement | null>(null)
const triggerRef = ref<HTMLElement | null>(null)
const props = __props
const active = ref(0);
const show = computed({
    get: () => props.dataSet.show,
    set: (val) => emits('update:show', val)
})
const tabList = ref(TAB_LIST)
const tabsRef = ref();
const localValue = ref('')
const showPopover = computed({
    get: () => props.dataSet.showPopover,
    set: (val) => emits('update:showPopover', val)
})
const emits = __emit

const activeItemIcon = computed(() => {
    const item = props.dataSet.groupList.find((i: any) => i.id == props.dataSet.activeItem);
    return item?.icon;
});

const open = (id: number | string) => {
    emits('open', id)
}
const close = () => {
    active.value = 0
    emits('close')
}
const goToProfile = () => {
    emits('goToProfile')
}
const selectGroup = (item: any) => {
    emits('selectGroup', item)
}
const loadMoreGame = () => {
    emits('loadMoreGame')
}
const goToDeposit = () => {
    emits('goToDeposit')
}
const onClickTab = (value: any) => {
    active.value = value.name
    localValue.value = ''
    emits('onClickTab', value)
}
const getGameTabData = () => {
    if (active.value == 3) {
        emits('getGameTabData')
    }
}
const handleClickOutside = (event: MouseEvent) => {
    const popoverEl = popoverRef.value
    const triggerEl = triggerRef.value
    if (
        popoverEl &&
        !popoverEl.contains(event.target as Node) &&
        triggerEl &&
        !triggerEl.contains(event.target as Node)
    ) {
        showPopover.value = false
    }
}
const goToPlayGame = (ID: any, makerID: any, favorite: number, favId: any) => {
    let data = {
        id: ID,
        makerId: makerID,
        isFavorite: favorite,
        favId: favId

    }
    emits('goToPlayGame', data)
}
const searchGames = () => {
    active.value = 0
    emits('searchGames', localValue.value)
}
watch(() => props.dataSet.show, (newVal) => {
    if (newVal) {
        setTimeout(() => {
            tabsRef.value?.resize();
        }, 100);
    }
});
__expose({
    open,
})
onMounted(() => {
    document.addEventListener('click', handleClickOutside)
})

onBeforeUnmount(() => {
    document.removeEventListener('click', handleClickOutside)
})

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: show.value,
    "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((show).value = $event)),
    position: "right",
    style: {
        minWidth: '100%',
        minHeight: '100%',
        background: 'green',
        color: '#fff',
        overflow: 'hidden',
    }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_van_row, { class: "header" }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "3",
              class: "backIcon"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "",
                  onClick: close
                })
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, {
              class: "header_item_logo",
              span: "8"
            }, {
              default: _withCtx(() => [
                (__props.dataSet?.mainHeader.display)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: __props.dataSet?.mainHeader.url,
                      alt: ""
                    }, null, 8, _hoisted_2))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (_unref(userStore).loginAccount)
              ? (_openBlock(), _createBlock(_component_van_col, {
                  key: 0,
                  span: "13",
                  class: "header_button_item",
                  align: "center"
                }, {
                  default: _withCtx(() => [
                    (__props.dataSet?.depositButon.display)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          onClick: goToDeposit,
                          class: "coin_btn",
                          style: _normalizeStyle({ backgroundImage: __props.dataSet?.depositButon.colorCode })
                        }, [
                          _createElementVNode("div", null, _toDisplayString(__props.dataSet?.balance), 1),
                          _cache[3] || (_cache[3] = _createElementVNode("span", null, [
                            _createElementVNode("img", {
                              src: _imports_1,
                              alt: ""
                            })
                          ], -1))
                        ], 4))
                      : _createCommentVNode("", true),
                    (__props.dataSet?.profileButtonData.display)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _createElementVNode("img", {
                            src: _imports_2,
                            alt: "",
                            onClick: goToProfile
                          }),
                          _createElementVNode("span", _hoisted_4, [
                            _createElementVNode("img", {
                              src: __props.dataSet?.profileButtonData.url,
                              alt: ""
                            }, null, 8, _hoisted_5)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_van_field, {
            modelValue: localValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localValue).value = $event)),
            type: "text",
            placeholder: _ctx.$t('home.searchGames'),
            class: "custom-field"
          }, {
            "right-icon": _withCtx(() => [
              _createElementVNode("div", { class: "left-section" }, [
                _createElementVNode("img", {
                  src: _imports_3,
                  alt: "",
                  width: "15%",
                  style: {"opacity":"0.4"},
                  onClick: searchGames
                })
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder"])
        ]),
        _createVNode(_component_van_row, { class: "game_container" }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "6",
              style: {"height":"80%"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dataSet?.groupList, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id,
                      class: _normalizeClass(["game_menu_item", __props.dataSet?.activeItem === item.id ? 'active_group' : '']),
                      onClick: ($event: any) => (selectGroup(item))
                    }, [
                      _createElementVNode("img", {
                        src: item.icon,
                        alt: ""
                      }, null, 8, _hoisted_9),
                      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t(item.name)), 1)
                    ], 10, _hoisted_8))
                  }), 128))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "18",
              class: "rightSide"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_tabs, {
                  active: active.value,
                  "onUpdate:active": _cache[1] || (_cache[1] = ($event: any) => ((active).value = $event)),
                  ref_key: "tabsRef",
                  ref: tabsRef,
                  sticky: "",
                  ellipsis: false,
                  onClickTab: onClickTab
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (item, index) => {
                      return (_openBlock(), _createBlock(_component_van_tab, {
                        key: index,
                        title: _ctx.$t(item.name),
                        name: item.id
                      }, null, 8, ["title", "name"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["active"]),
                (__props.dataSet?.gameList?.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createVNode(_component_van_row, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dataSet?.gameList, (item, index) => {
                            return (_openBlock(), _createBlock(_component_van_col, {
                              span: "8",
                              class: "game_item",
                              key: index
                            }, {
                              default: _withCtx(() => [
                                _createVNode(GameCard, {
                                  gameImage: item.customIcon,
                                  onClickGameCard: ($event: any) => (goToPlayGame(item.activeGameId, item.gameMakerId, item.isFavorite, item.id)),
                                  gameTypeId: item.id,
                                  gameIsFavorite: item.isFavorite,
                                  onUpdateGameCategories: getGameTabData
                                }, null, 8, ["gameImage", "onClickGameCard", "gameTypeId", "gameIsFavorite"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }),
                      (__props.dataSet?.gameList.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            (__props.dataSet.activeItem != 'fav')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                  (!__props.dataSet?.loading && __props.dataSet?.showLoadMore)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "load_more_btn",
                                        onClick: loadMoreGame
                                      }, [
                                        _createTextVNode(_toDisplayString(_ctx.$t('common.loadMore')) + " ", 1),
                                        _cache[4] || (_cache[4] = _createElementVNode("img", {
                                          src: _imports_4,
                                          alt: ""
                                        }, null, -1))
                                      ]))
                                    : _createCommentVNode("", true),
                                  (__props.dataSet?.loading)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        class: "loading_btn",
                                        onClick: loadMoreGame
                                      }, [
                                        _createVNode(_component_van_loading, { size: "20" }),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('common.loading')), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createVNode(NoData)
                    ]))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})